import { GlobeAltIcon } from '@heroicons/react/24/outline';

import { NoDataProps } from '@/components/legacy-ui/NoData';
import {
  createAllEmptyConfig,
  createFilteredEmptyConfig,
  NO_DATA_ICON_CLASS,
} from '@/components/legacy-ui/utils/createNoDataConfig';

interface TechnologyNoDataConfigParams {
  isAllEmpty: boolean;
  isFilteredEmpty: boolean;
  hasActiveFilters: boolean;
  onClearFilters: () => void;
  /** Callback when "Get Started" button is clicked (for first-time users) */
  onGetStarted?: () => void;
}

/**
 * Generates NoData configuration for technology table empty states
 *
 * Handles two scenarios:
 * 1. All Empty - First-time user with no technologies discovered yet
 * 2. Filtered Empty - User has technologies but current filters return none
 *
 * @param params - Configuration parameters
 * @returns NoData component props
 */
export const getTechnologyNoDataConfig = ({
  isAllEmpty,
  isFilteredEmpty,
  hasActiveFilters,
  onClearFilters,
  onGetStarted,
}: TechnologyNoDataConfigParams): NoDataProps => {
  const icon = <GlobeAltIcon className={NO_DATA_ICON_CLASS} />;

  // All Empty State (First time user)
  if (isAllEmpty) {
    return createAllEmptyConfig({
      entityName: 'No Technology to Show Yet',
      icon,
      description: (
        <p>
          Technologies are discovered when you populate your attack surface.
        </p>
      ),
      onGetStarted,
    });
  }

  // Filtered Empty State
  return createFilteredEmptyConfig({
    entityName: 'Technology',
    icon,
    hasActiveFilters: hasActiveFilters && isFilteredEmpty,
    onClearFilters,
  });
};
